import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import UserFilter from '../components/filters/user-filter';
import UserForm from '../components/forms/user-form';
import UsersTable from '../components/tables/users-table';

const UsersListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="کاربران"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/users-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <UserFilter onFinish={setFitlers} />
    <UsersTable filters={filters} />
  </>);
}

export default UsersListRoute;
